import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonProperty, MessageType } from '../dialog-index';
import { DialogOption } from '../dialog-option';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.css']
})
export class DialogConfirmComponent {
  @Input() public dlgOption: DialogOption;
  header: string;
  message: string;
  messageClass: string;
  buttons: ButtonProperty[];

  constructor(public modal: NgbActiveModal, private el: ElementRef) {
    console.log('dialog-confirm');
  }

  //only run once
  ngOnInit() {
    console.log(this.dlgOption);
    this.header = this.dlgOption.header;
    this.message = this.dlgOption.message;

    if (typeof (this.dlgOption.buttons) !== 'undefined') {
      //this.dlgOption.buttons
      this.buttons = this.dlgOption.buttons;

    }
    else {
      //build default dismiss button
      this.buttons = [{
        text: 'Ok', btnFunction: function () {
          this.modal.dismiss('dismiss');
        }
      }];
    }

    if (typeof (this.dlgOption.messageClass) === 'undefined')
      this.dlgOption.messageClass = MessageType.Success;
    this.messageClass = this.dlgOption.messageClass;
  }

  ngAfterViewInit() {
    // View has been initialized!
  }

  onButtonClick(text: string) {
    let btn = this.buttons.filter(x => x.text == text)[0];
    if (btn.btnFunction())
      this.modal.close(btn.text);
  }

  Dismiss() {
    if (typeof (this.dlgOption.cancelFN) === 'function') {
      this.dlgOption.cancelFN('cancel modal from callback');
    }
    this.modal.dismiss('dismiss');
  }

  ConfirmClick() {
    if (typeof (this.dlgOption.confirmFN) === 'function') {
      this.dlgOption.confirmFN('close modal from callback');
    }
    this.modal.close('close modal');
  }
}
